import React, {useEffect} from 'react';
import Right_panel from '../components/login_signup_Panels/right_panel';
import Left_panel from '../components/login_signup_Panels/left_panel';

function Signup() {

  
  useEffect(() => {
    document.title = 'Signup';
  },[])


  return (
    <div className='md:grid md:grid-cols-3'>
      {/* left panel */}
        <Left_panel isLogin={false} />
      {/* right panel */}
        <Right_panel />
    </div>
  )
}

export default Signup